var n=function(n){return n.GDS="GDS",n.Active="Active",n.Inactive="Inactive",n.Unknown="Unknown",n.Liquidated="Liquidated",n}({});export{n as MapIconType};
//# sourceMappingURL=types.js.map